import Vuex from 'vuex'
import Vue from 'vue'
import mutations from './mutations'
import actions from './actions'

Vue.use(Vuex)
export default new Vuex.Store({
    state: {
        login: false, // 是否登录
        mailsList: [],
        list: [],
        folderId: '',
        mailSort: 0,
        skin: {},
        searchText: '',
        userInfo: {},
        contact: {},
        mailFolders: {
            other: [],
            multiMails: []
        },
        originFolders: {},
        mailData: {},
        baseSet: {
            autoSaveContact: true,
            autoSaveInterval: 3,
            // displayName: '',
            // httpsFilter: true,
            includeOrigin: true,
            pageCount: 20,
            replyPrefix: '回复:',
            // sessionMode: false,
            showSenderAddr: true
        },
        folderIndex: {
            '未读邮件': 'unread',
            '收件箱': 'recv',
            '草稿箱': 'draft',
            '已发送': 'send',
            '已删除': 'deleted',
            '垃圾邮件': 'spam',
            '待办邮件': 'gtasks',
            '星标邮件': 'star',
            '重要联系人邮件': 'important'
        },
        dialog: false,
        column: false
    },
    actions,
    mutations
})



// WEBPACK FOOTER //
// ./src/store/index.js